import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  BASE_URL,
  CHECK_ADMIN_EMP_PIN,
  CHECK_EMAIL_VALIDATION,
  CHECK_EMP_PIN,
  CHECK_PIN_VALIDATION,
  LIST_ALL_EMPLOYEE,
} from "../../../Constants/Config";

const initialState = {
  loading: false,
  employeeListData: [],
  successMessage: "",
  error: "",

  loadingPin:false,
};

// Generate pening , fulfilled and rejected action type
export const fetchEmployeeListData = createAsyncThunk(
  "isEmployeeList/fetchEmployeeListData.",
  async (data, { rejectWithValue }) => {
    try {
      const { token, ...dataNew } = data;
      const response = await axios.post(BASE_URL + LIST_ALL_EMPLOYEE, dataNew, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data.status === true) {
        const result = response.data.result;
        return Array.isArray(result) ? result : [];
      }
      return rejectWithValue(
        response.data?.message || "Failed to fetch employee list",
      );
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to fetch employee list",
      );
    }
  }
);

export const checkEmailValidation = createAsyncThunk(
  "isEmployeeList/checkEmailValidation",
  async (data) => {
    try {
      const { token, ...dataNew } = data;
      const response = await axios.post(
        BASE_URL + CHECK_EMAIL_VALIDATION,
        dataNew,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const checkPinValidation = createAsyncThunk(
  "isEmployeeList/checkPinValidation",
  async (data) => {
    try {
      const { token, ...dataNew } = data;
      const response = await axios.post(
        BASE_URL + CHECK_PIN_VALIDATION,
        dataNew,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

const employeeListDataSlice = createSlice({
  name: "isEmployeeList",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchEmployeeListData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchEmployeeListData.fulfilled, (state, action) => {
      state.loading = false;
      state.employeeListData = Array.isArray(action.payload)
        ? action.payload
        : [];
      state.error = "";
    });
    builder.addCase(fetchEmployeeListData.rejected, (state, action) => {
      state.loading = false;
      // Keep an array — `{}` is truthy and breaks consumers calling `.map`.
      state.employeeListData = [];
      state.error = action.payload || action.error.message;
    });

    builder.addCase(checkPinValidation.pending, (state) => {
      state.loadingPin = true;
    });
    builder.addCase(checkPinValidation.fulfilled, (state, action) => {
      state.loadingPin = false;
    });
    builder.addCase(checkPinValidation.rejected, (state, action) => {
      state.loadingPin = false;
    });
  },
});

export default employeeListDataSlice.reducer;
